import { useDataValue, useDataSubmit } from 'Simple/Data.js'
import { useMutation } from 'Data/Api.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'

import mutation from './mutation.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data, reExecuteQuery) {
  let id = useDataValue({
    context: 'payor',
    path: 'contract.signature_request.id',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'payor',
    viewPath: props.viewPath,
  })
  let setFlowTo = useSetFlowTo(props.viewPath)
  let [, notify] = useNotifications()
  let [, executeMutation] = useMutation(mutation)

  return async function onSubmit({ value, args, change, reExecuteQuery }) {
    let mutationResponse = await executeMutation({ id })

    if (mutationResponse.error) {
      notify(notifyError(`Couldn't cancel signature request`))
      return
    }

    notify(notifySuccess(`Cancelled signature request`))
    submit({ type: 'reFetch' })
    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
